(function() {
  'use strict';

  angular.module('ringbaPortal').directive('linkedName', linkedName);

  function linkedName () {
    const directive = {
      restrict: 'E',
      transclude: true,
      replace: true,
      scope: {
        stateName: '@',
        stateParams: '<' // always pass the name in the object here. To reduce watchers I didn't add name as a separate binding
      },
      templateUrl: '/scripts/shared/directives/linked-name/linked-name.view.html'
    };

    return directive;
  }

})();
